if (!customElements.get('video-container')) {

  class Player extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.videoContent = this.querySelector('[data-video-content]');
      this.playButton = this.querySelector('[data-play-button]');
      this.container = this.querySelector('[data-fancybox]');

      this.playButton.addEventListener("click", (e) => {
        e.preventDefault();

        // If Fancybox is enabled, let Fancybox handle the click
        if (this.container && this.container.hasAttribute('data-fancybox')) {
          // Trigger click on the container to open Fancybox
          this.container.click();
          return;
        }

        this.video.play();
      });

      // Add click handler to video content area when Fancybox is enabled
      if (this.container && this.container.hasAttribute('data-fancybox')) {
        this.videoContent.addEventListener("click", (e) => {
          // Don't trigger if clicking on the play button (already handled above)
          if (e.target.closest('[data-play-button]')) {
            return;
          }
          this.container.click();
        });
      }

      // Pause video on click of video element
      if (!this.container || !this.container.hasAttribute('data-fancybox')) {
        this.video.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (this.video.paused) {
            this.video.play();
          } else {
            this.video.pause();
          }
        });
      }

      // When video starts playing
      this.video.addEventListener("play", (e) => {

        // Show controls
        if (this.video.hasAttribute('data-controls')) {
          this.video.setAttribute('controls', true);
        }

        // Hide content
        this.videoContent.classList.add('visibility-hidden');

        // pause all other video's, reaload for showing poster, remove controls and show play button
        document.querySelectorAll("video-container").forEach((el) => {
          let video = el.querySelector('video');
          if (video != this.video) {
            video.load();
            video.pause();
            video.removeAttribute('controls');
            el.videoContent.classList.remove('visibility-hidden');
          }
        });
      })

      // When video is paused
      this.video.addEventListener("pause", (e) => {
        this.video.removeAttribute('controls');
        this.video.removeAttribute('autoplay');
        this.videoContent.classList.remove('visibility-hidden');
      })
    }
  }

  window.Player = Player;
  customElements.define('video-container', Player);
}
